import { createContext } from 'react';
export var SkipLinkType;
(function (SkipLinkType) {
    SkipLinkType["Footer"] = "footer";
    SkipLinkType["Sidebar"] = "sidebar";
    SkipLinkType["Content"] = "content";
})(SkipLinkType || (SkipLinkType = {}));
export const SkipLinkContext = createContext({
    registerFocusObject: () => { },
    unregisterFocusObject: () => { },
    focus: () => { },
});
//# sourceMappingURL=SkipLinkContext.js.map